import React, { SVGProps } from 'react';

const PromotionsIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<g clipPath="url(#clip0_22753_112316)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.92031 4.2484C3.5124 1.98945 5.36693 0.141452 7.61291 0.559347C8.78648 0.777285 9.52582 1.58813 10.0004 2.62514C10.4749 1.58813 11.2143 0.777285 12.3879 0.559347C14.6339 0.141579 16.4885 1.98945 16.0805 4.2484C15.6035 6.88904 12.1575 7.27557 10.0876 7.48862H9.91402C7.84403 7.27481 4.39818 6.88828 3.92111 4.2484H3.92031ZM2.16941 20.5H9.14342V13.4185H1.70223C1.48676 13.4185 1.31158 13.5937 1.31158 13.8092V19.6431C1.31158 20.1159 1.69564 20.5 2.16852 20.5L2.16941 20.5ZM17.8323 20.5H10.8582V13.4185H18.2986C18.5141 13.4185 18.6892 13.5937 18.6892 13.8092V19.6431C18.6892 20.1159 18.3051 20.5 17.8323 20.5ZM4.21142e-05 9.03199C4.21142e-05 8.55912 0.383281 8.17508 0.856988 8.17508H9.14264V12.1307L0.39065 12.1298C0.175187 12.1298 0 11.9547 0 11.7392V9.03121L4.21142e-05 9.03199ZM10.8574 8.17508H19.1431C19.6168 8.17508 20 8.55912 20 9.03199V11.74C20 11.9554 19.8248 12.1306 19.6093 12.1306H10.8565V8.17504L10.8574 8.17508ZM10.9668 5.66855C12.0573 5.52217 14.1791 5.16609 14.3987 3.94733C14.5928 2.87249 13.7836 2.03779 12.6955 2.24009C11.4833 2.46541 11.1132 4.57883 10.9668 5.66767L10.9668 5.66855ZM7.10638 5.25078C7.70098 5.4572 8.38687 5.58137 9.03328 5.66855C8.88689 4.57973 8.51763 2.46623 7.30458 2.24097C6.21571 2.03867 5.40647 2.87337 5.60139 3.94821C5.71652 4.58472 6.34073 4.98605 7.10721 5.25167L7.10638 5.25078Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_22753_112316">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default PromotionsIcon;
